import clsx from 'clsx';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useHistory, useParams } from 'react-router-dom';
import { PageHeader, RedesignLayout, useSharedStyles } from '../../shared';
import { getBeneficiaryTestsBackPath } from '../../Tests/shared/adminResultNav';
import CompassHero from '../components/CompassHero';
import CompassSections from '../components/CompassSections';
import HistoryButton from '../components/HistoryButton';
import { useAdminCompassPage } from '../hooks/useAdminCompassPage';
import { useCompassStyles } from '../index.styles';
import locale from '../locale.json';

const AdminCompass = () => {
  const classes = useCompassStyles();
  const sharedClasses = useSharedStyles();
  const history = useHistory();
  const { userId }: any = useParams();
  const { loading, harmonyTestLastResult, canAccessNeeds, showNeeds, showNeedsPro } =
    useAdminCompassPage();

  if (loading) {
    return (
      <RedesignLayout footer={true} noPadding={true}>
        <div className={sharedClasses.loadingCenter}>
          <CircularProgress />
        </div>
      </RedesignLayout>
    );
  }

  return (
    <RedesignLayout footer={true} noPadding={true}>
      <div className={clsx(sharedClasses.pageShell, classes.page)}>
        <PageHeader
          onBack={() => history.push(getBeneficiaryTestsBackPath(userId))}
          title={locale.pageTitle}
          description={locale.pageDescription}
          titleVariant="primary"
          actions={<HistoryButton />}
        />

        <div className={classes.sectionsStack}>
          <CompassHero />
          <CompassSections
            harmonyTestLastResult={harmonyTestLastResult}
            loading={loading}
            canAccessNeeds={canAccessNeeds}
            showNeeds={showNeeds}
            showNeedsPro={showNeedsPro}
          />
        </div>
      </div>
    </RedesignLayout>
  );
};

export default AdminCompass;
